/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { debug, fetchRecords } from "../utils/AppUtil";
import { DeceasedInformationDefault } from "./DeceasedInformationDefault";
import { DeceasedInformationMobile } from "./DeceasedInformationMobile";


type DeceasedType = {
    deceasedId: string,
    title: string,
    firstName: string,
    lastName: string,
    middleName: string,
    hebrewName: string,
    tribe: string,
    gender: string,
    birthDate: string,
    birthDateDisplay: string,
    deathDate: string,
    deathDateDisplay: string,
    deathDateJewish: string,
    burialDateDisplay: string,
    burialTimeDisplay: string,
    consecrationDateDisplay: string,
    consecrationTimeDisplay: string,
    yahrzeitDateDisplay: string,
    yahrzeitDesc: string,
    cemeteryName: string,
    synagogueName: string,
    synagogueEmail: string,
    locationDesc: string,
    locationNumber: string,
    ashesDesc: string,
    metaTagTitle: string,
    metaTagDescription: string,
    metaTagKeywords: string
}

export const DeceasedInformation: React.FC = () => {

    type DeceasedParamsType = { deceasedId: string };
    const params: DeceasedParamsType = useParams();
    const endpoint = `deceased/${params.deceasedId}`;

    const deceasedData: DeceasedType = {
        deceasedId: "",
        title: "",
        firstName: "",
        lastName: "",
        middleName: "",
        hebrewName: "",
        tribe: "",
        gender: "",
        birthDate: "",
        birthDateDisplay: "",
        deathDate: "",
        deathDateDisplay: "",
        deathDateJewish: "",
        burialDateDisplay: "",
        burialTimeDisplay: "",
        consecrationDateDisplay: "",
        consecrationTimeDisplay: "",
        yahrzeitDateDisplay: "",
        yahrzeitDesc: "",
        cemeteryName: "",
        synagogueName: "",
        synagogueEmail: "",
        locationDesc: "",
        locationNumber: "",
        ashesDesc: "",
        metaTagTitle: "",
        metaTagDescription: "",
        metaTagKeywords: ""
    }
    const [deceased, setDeceased] = useState<DeceasedType>(deceasedData);
    const processData = (responseJson: DeceasedType) => {
        setDeceased(responseJson);
    }

    // Do not change this or put any additional code in here without checking with
    // the team first.
    useEffect(() => {

        fetchRecords(endpoint, processData)
        .catch((error) => {
            console.log("Error : " + error)
        });

    }, [endpoint]);

    if (deceased.gender == "MALE") {
        deceased.gender = "Male";
    }

    if (deceased.gender == "FEMALE") {
        deceased.gender = "Female";
    }

    return(
        <>
            {(window.innerWidth <= 480) &&
                <DeceasedInformationMobile 
                    deceasedId={params.deceasedId} 
                    firstName={deceased.firstName} 
                    lastName={deceased.lastName} 
                    hebrewName={deceased.hebrewName} 
                    yahrzeitDateDisplay={deceased.yahrzeitDateDisplay} 
                    yahrzeitDesc={deceased.yahrzeitDesc} 
                    gender={deceased.gender} 
                    tribe={deceased.tribe} 
                    synagogueName={deceased.synagogueName} 
                    cemeteryName={deceased.cemeteryName} 
                    locationNumber={deceased.locationNumber} 
                    birthDateDisplay={deceased.birthDateDisplay} 
                    deathDateDisplay={deceased.deathDateDisplay}
                    deathDateJewish={deceased.deathDateJewish}
                    burialDateDisplay={deceased.burialDateDisplay} 
                    burialTimeDisplay={deceased.burialTimeDisplay} 
                    consecrationDateDisplay={deceased.consecrationDateDisplay} 
                    consecrationTimeDisplay={deceased.consecrationTimeDisplay}
                />
            }

            {(window.innerWidth > 480) &&
                <DeceasedInformationDefault 
                    deceasedId={params.deceasedId} 
                    firstName={deceased.firstName} 
                    lastName={deceased.lastName} 
                    hebrewName={deceased.hebrewName} 
                    yahrzeitDateDisplay={deceased.yahrzeitDateDisplay} 
                    yahrzeitDesc={deceased.yahrzeitDesc} 
                    gender={deceased.gender} 
                    tribe={deceased.tribe} 
                    synagogueName={deceased.synagogueName} 
                    cemeteryName={deceased.cemeteryName} 
                    locationNumber={deceased.locationNumber} 
                    birthDateDisplay={deceased.birthDateDisplay} 
                    deathDateDisplay={deceased.deathDateDisplay}
                    deathDateJewish={deceased.deathDateJewish}
                    burialDateDisplay={deceased.burialDateDisplay} 
                    burialTimeDisplay={deceased.burialTimeDisplay} 
                    consecrationDateDisplay={deceased.consecrationDateDisplay} 
                    consecrationTimeDisplay={deceased.consecrationTimeDisplay}
                />
            }
        </>
    );
}